import React from "react";

export function BreakSessionDetailModalBody(props) {
    return (
        <div className="panel panelbreak">
            <div className="break">
                <div className="panel-body">
                    <div className="breakname">{props.session.data.name}</div>
                </div>
            </div>
        </div>
    )
}
